/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".product-benefits").forEach(container => {
//     const visibleCount = parseInt(container.dataset.visibleCount, 10);
//     const tags = container.querySelectorAll(".benefit-tag");
//     const moreBadge = container.querySelector(".benefit-more");

//     if (tags.length > visibleCount) {
//       tags.forEach((tag, index) => {
//         if (index >= visibleCount) tag.style.display = "none";
//       });

//       const hiddenCount = tags.length - visibleCount;
//       moreBadge.textContent = `+${hiddenCount}`;
//       moreBadge.hidden = false;
//     }
//   });
// });
document.body.addEventListener('click', function (e) {
    const button = e.target.closest('.benefit-more');
    if (!button) return;

    const container = button.closest('.product-benefits');
    const visibleCount = parseInt(container.dataset.visibleCount) || 2;
    const tags = container.querySelectorAll('.benefit-tag');
    const totalCount = tags.length;
    const hiddenCount = totalCount - visibleCount;

    if (button.classList.contains('expanded')) {
        // Collapse
        tags.forEach((tag, index) => {
            if (index >= visibleCount) {
                tag.classList.add('hidden');
            }
        });

        button.classList.remove('expanded');
        button.textContent = `+ ${hiddenCount}`;

    } else {
        // Expand
        tags.forEach(tag => tag.classList.remove('hidden'));

        button.classList.add('expanded');
        button.textContent = `-`;
    }
});

  /*function initProductBenefits() {
    document.querySelectorAll('.js-product-benefits').forEach((container) => {
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';

      const visibleCount = parseInt(container.dataset.visibleCount || 2, 10);
      const tags = Array.from(container.querySelectorAll('.benefit-tag'));
      const moreBadge = container.querySelector('.benefit-more');

      if (tags.length <= visibleCount) return;

      // Hide extra tags initially
      tags.forEach((tag, index) => {
        if (index >= visibleCount) tag.style.display = 'none';
      });

      const hiddenCount = tags.length - visibleCount;
      moreBadge.textContent = `+${hiddenCount}`;
      moreBadge.style.display = 'inline-block';
      moreBadge.style.cursor = 'pointer';

      let expanded = false;

      moreBadge.addEventListener('click', () => {
        expanded = !expanded;

        tags.forEach((tag, index) => {
          if (index >= visibleCount) {
            tag.style.display = expanded ? 'inline-block' : 'none';
          }
        });

        moreBadge.textContent = expanded ? '−' : `+${hiddenCount}`;
      });
    });
  }*/

  
